import { render, staticRenderFns } from "./TaxReturnYearlyDigitales.vue?vue&type=template&id=12d03eb7&scoped=true"
import script from "./TaxReturnYearlyDigitales.vue?vue&type=script&lang=js"
export * from "./TaxReturnYearlyDigitales.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnYearlyDigitales.vue?vue&type=style&index=0&id=12d03eb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d03eb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d03eb7')) {
      api.createRecord('12d03eb7', component.options)
    } else {
      api.reload('12d03eb7', component.options)
    }
    module.hot.accept("./TaxReturnYearlyDigitales.vue?vue&type=template&id=12d03eb7&scoped=true", function () {
      api.rerender('12d03eb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnYearlyDigitales.vue"
export default component.exports